import React from 'react'
import Chart from 'react-apexcharts'
import { merge } from 'lodash'
import { defaultTypography, ptBr } from './types/index'
import { ChartBarOptions, ChartBarSeries, ChartBarThemes, themes } from './types/ChartBar'
import { formatNumber } from '../../utils/Helpers'

type Props = {
  options: ChartBarOptions
  series: ChartBarSeries[],
  theme?: ChartBarThemes,
  height?: number
}

const ChartBar = ({ options, series, theme = ChartBarThemes.default, height = 740 }: Props): JSX.Element => {
  const defaultOptions = {
    colors: themes[theme].seriesColors,
    chart: {
      toolbar: {
        show: false
      },
      locales: [ptBr],
      defaultLocale: 'pt-br',
      ...defaultTypography
    },
    tooltip: {
      style: {
        ...defaultTypography
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: true,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetX: 20,
      formatter: (val: number) => {
        return formatNumber(val, 0)
      },
      enabled: true,
      style: {
        colors: ['#304758'],
        ...defaultTypography
      }
    },
    xaxis: {
      labels: {
        datetimeUTC: false
      }
    },
    yaxis: {
      labels: {
        minWidth: 20,
        maxWidth: 320,
        style: {
          colors: ['#4B4B4B'],
          ...defaultTypography
        }
      }
    },
    noData: {
      text: 'No data found :(',
      style: {
        fontSize: '12pt',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        color: '#4B4B4B',
        fontWeight: 400
      }
    }
  }

  return (
    <Chart options={merge(defaultOptions, options)} series={series} type="bar" height={height} />
  )
}

export default ChartBar
